import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  Grid, Button, Stack, Box, Collapse, Autocomplete, TextField,
  Paper, Typography, Badge,  IconButton, FormControl, InputLabel, Select, 
  MenuItem,
} from '@mui/material';

import {
  selectRequestIds, 
  selectRequestById
} from '../../store/requestSlice'

import {useViewContext} from '../../utils/ViewContext';

import {  parse, formatDistanceToNow, } from 'date-fns'

import {useNavigate} from 'react-router-dom' 

import {usePlayContext} from '../../utils/PlayContext';

import {  selectAllApplications, 
  refreshApplications,
          selectApplicationById,
          selectApplicationStatus,
          selectAllSubjects,
          selectApplicationByFilter} from '../../store/applicationSlice' 

import {  
  selectAllFloors,
}  from '../../store/floorSlice'


import Tooltip from '@mui/material/Tooltip';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';

import WalkinIcon from '@mui/icons-material/Snowshoeing';

import ApproveIcon from '@mui/icons-material/Done';
import DenyIcon from '@mui/icons-material/Close';

import CourierIcon from '@mui/icons-material/DeliveryDining';
import PersonIcon from '@mui/icons-material/Person';

import PassIcon from '@mui/icons-material/BookmarkAdded';
import InactivePassIcon from '@mui/icons-material/BookmarkRemove';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import RefreshIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';

import { DesktopTimePicker, DesktopDatePicker } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';

const InvitationFilterPane=()=>{

  const {
    setOp,
    status, setStatus, appTitle, setAppTitle, 
    errorMessage, setErrorMessage, errorTitle, setErrorTitle,
    setTenantLogo
  }=usePlayContext()


  const {
    viewFilter, setViewFilter
  }=useViewContext()

      const allSubjects = useSelector(selectAllSubjects)
      
      const dispatch = useDispatch();
      const navigate = useNavigate()
      
      const floors = useSelector(selectAllFloors)

      const [name, setName] = React.useState(viewFilter?.name? viewFilter?.name:'')
      const [phone, setPhone] = React.useState(viewFilter?.phone? viewFilter?.phone:'')
      const [email, setEmail] = React.useState(viewFilter?.email ? viewFilter?.email:''  );
      const [company, setCompany] = React.useState(viewFilter?.company ? viewFilter?.company:'');
      
      const [start, setStart] = React.useState(viewFilter?.start)
      const [end, setEnd] = React.useState(viewFilter?.end)
      const [floor, setFloor] = React.useState(viewFilter?.floor ? viewFilter?.floor:''  );
      const [subject, setSubject] = React.useState(viewFilter?.subject ? viewFilter?.subject:'');
        const [expanded, setExpanded] = React.useState(true);
        const handleExpandClick = () => {
          setExpanded(!expanded);
        };

        const handleReset = ()=>{
            setStart(null)
            setEnd(null)
            setFloor('')
            setSubject('')

            setViewFilter({
              start:null,
              end:null,
              floor:'',
              subject:'',

          })
        }

        const doToday= ()=>
        {
            const __dd=(x)=>
            {
                if (x) return x.trim().toLowerCase();
                return x;
            }
            //alert("name2="+__dd(name))
            let start = new Date()
            setFloor('')
            setSubject('')

            setStart(start)
            setEnd(start)

            let newVal = 
            {
              start: start,
              end: start, 
              floor : null, 
              subject: null,
            }
            setViewFilter(newVal)

        }
        const doThisWeek= ()=>
        {
            const __dd=(x)=>
            {
                if (x) return x.trim().toLowerCase();
                return x;
            }
           
            const today = new Date();
            const firstday = new Date(today.setDate(today.getDate() - today.getDay()));
            const lastday = new Date(today.setDate(today.getDate() - today.getDay() + 6));

            setFloor('')
            setSubject('')
            setStart(firstday)
            setEnd(lastday)

            let newVal = 
            {
              start: firstday,
              end: lastday, 
              floor:null, 
              subject:   null, //__dd(subject),
            }
            setViewFilter(newVal)

        }
        const doThisMonth= ()=>
        {
            const __dd=(x)=>
            {
                if (x) return x.trim().toLowerCase();
                return x;
            }
           

            const now = new Date();
            const firstday = new Date(now.getFullYear(), now.getMonth(), 1);
            //console.log(firstday); // 👉️ Sat Oct 01 2022 ...

            const lastday = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            //console.log(lastday); // 👉️ Mon Oct 31 2022 ...
            setFloor('')
            setSubject('')
            setStart(firstday)
            setEnd(lastday)

            let newVal = 
            {
              start: firstday,
              end: lastday, 
              floor:null, 
              subject:   null, //__dd(subject),
            }
            setViewFilter(newVal)

        }

        const doFilterApplication= ()=>
        {
            //alert("name="+name)

            const __dd=(x)=>
            {
                if (x) return x.trim().toLowerCase();
                return x;
            }
            //alert("name2="+__dd(name))

            let start1 = Boolean(start) && !isNaN(start) ? 
                new Date(start.getFullYear(), start.getMonth(), start.getDate()):
                null
            let end1 = Boolean(end) && !isNaN(end) ? 
              new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59,999):
              null
              

            let newVal = 
            {
              start: start1,
              end: end1, 
              floor, 
              subject: __dd(subject),
            }
            setViewFilter(newVal)

        }
        
        const doRefresh = async ()=>{
        
          handleReset()
        
          setStatus('processing')
        
        
          try
          {
            let resp = await dispatch(          refreshApplications()).unwrap();

              setStatus('idle')
          }
          catch (ex)
          {
            setStatus('error')
            setErrorMessage("Cannot retrieve Visitor info")
          } 
        }

  return (
    <Card  
          
          sx={{mt:1, p:0, border:1}}>
          <CardActions  disableSpacing   sx={{p:0,m:0, }}> 
            
              <Typography sx={{marginLeft:'auto'}} onClick={handleExpandClick }>Filter&nbsp; </Typography>
              <IconButton size='large' 
                onClick={handleExpandClick }
              >
                {  expanded ? <ExpandLessIcon />:<ExpandMoreIcon />}
              </IconButton>
          </CardActions>
          <Collapse in={expanded} timeout="auto" unmountOnExit>

            <CardContent>
              <Grid  container 
                          spacing={2}
                          columns={24}
                          sx={{py:0, 
                          mb:{xs:0, md:0},
                          px:{xs:1, md:0},
                          border:{xs:0,md:0},
                          borderColor:'#aaaaaa',
                          borderRadius:1,
                          }}>
                <Grid item xs={24} sm={12}  md={6} lg={4}>
                  <Autocomplete 
                      fullWidth
                      size='small'
                      freeSolo
                      selectOnFocus
                      handleHomeEndKeys
                      //disableClearable
                      id="id_reason" 
                      value={subject}
                      options={allSubjects} 
                      onChange = { (e, newValue)=>{setSubject(newValue);   } }
                      renderInput={(params) => 
                          <TextField {...params} 
                            onChange = { e=>{setSubject(e.target.value);}}
                            label="Subject"  
                            //inputProps={{ maxLength: 100, minLength:5 }}
                            //helperText={ Boolean(reasonVisitError) ? reasonVisitError : "Subject for the visit"}
                            />}

                      />
        
                </Grid>
                <Grid item xs={24} sm={12}  md={6} lg={4}>
            
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker 
                      label="Start Date"
                      onChange={(newValue) => {  setStart(newValue);}}
                      value={start}

                      inputFormat="dd/MM/yyyy"

                      renderInput={(props) => 
                      <TextField {...props} 
                          
                          fullWidth 
                          size='small'
                          />}
                      
                      />
                  </LocalizationProvider>
             </Grid>
             <Grid item xs={24} sm={12}  md={6} lg={4}>
            
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker 
                      inputFormat="dd/MM/yyyy"
                      renderInput={(props) => 
                      <TextField {...props} 
                          
                          size='small'
                          fullWidth 
                          
                          />}
                      label="End Date"
                      value={end}
                      onChange={(newValue) => {  setEnd(newValue);}}
                  />
                  </LocalizationProvider>
              </Grid>
              <Grid item xs={24} sm={12}  md={6} lg={4}>
            
                    <FormControl  fullWidth  size='small'>
                      <InputLabel id="id_floor_label" >Floor</InputLabel>
                        <Select
                            required
                            labelId="id_floor_label"
                            //error={Boolean(siteError)}
                            id="id_flooe"
                            value={floor}
                            label='Floor'
                            onChange={(e)=>setFloor(e.target.value)}
                            >
                          <MenuItem value={''}></MenuItem>
                            {
                                floors.map( (ct)=>
                                  (<MenuItem key={ct.id} value={ct.name}>{ct.name}</MenuItem>)
                                )
                            }
                      </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={24} sm={12}  md={6} lg={4}>
            
                  <Autocomplete 
                      fullWidth
                      size='small'
                      freeSolo
                      selectOnFocus
                      handleHomeEndKeys
                      id="id_name" 
                      value={name}
                      options={[]} 
                      onChange = { (e, newValue)=>{setName(newValue);   } }
                      renderInput={(params) => 
                          <TextField {...params} 
                            onChange = { e=>{setName(e.target.value);}}
                            label="Name"  
                            //inputProps={{ maxLength: 100, minLength:5 }}
                            //helperText={ Boolean(reasonVisitError) ? reasonVisitError : "Subject for the visit"}
                            />}

                      />
        
                </Grid>
                <Grid item xs={24} sm={12}  md={6} lg={4}>
            
                  <Autocomplete 
                      fullWidth
                      size='small'
                      freeSolo
                      selectOnFocus
                      handleHomeEndKeys
                      id="id_phone" 
                      value={phone}
                      options={[]} 
                      onChange = { (e, newValue)=>{setPhone(newValue);   } }
                      renderInput={(params) => 
                          <TextField {...params} 
                            onChange = { e=>{setPhone(e.target.value);}}
                            label="Phone"  
                            //inputProps={{ maxLength: 100, minLength:5 }}
                            //helperText={ Boolean(reasonVisitError) ? reasonVisitError : "Subject for the visit"}
                            />}

                      />
                </Grid>
                <Grid item xs={24} sm={12}  md={6} lg={4}>
                  <Autocomplete 
                      fullWidth
                      size='small'
                      freeSolo
                      selectOnFocus
                      handleHomeEndKeys
                      id="id_email" 
                      value={email}
                      options={[]} 
                      onChange = { (e, newValue)=>{setEmail(newValue);   } }
                      renderInput={(params) => 
                          <TextField {...params} 
                            onChange = { e=>{setEmail(e.target.value);}}
                            label="Email"  
                            />}
                      />
                </Grid>
                <Grid item xs={24} sm={12}  md={6} lg={4}>
                  <Autocomplete 
                      fullWidth
                      size='small'
                      freeSolo
                      selectOnFocus
                      handleHomeEndKeys
                      id="id_company" 
                      value={company}
                      options={[]} 
                      onChange = { (e, newValue)=>{setCompany(newValue);   } }
                      renderInput={(params) => 
                          <TextField {...params} 
                            onChange = { e=>{setCompany(e.target.value);}}
                            label="Organization"  
                            />}
                      />
                </Grid>
                <Grid item xs={24}  md={12} lg={12}  >
                    <Box sx={{ display:'flex', flexDirection:'row', justifyContent: 'space-around' , m:0,p:0, 
                        width:'100%'}}>
                        <Button variant="outlined"size='small' color='primary' 
                                onClick={doToday}
                                sx={{textTransform:'none'}}
                              >
                            Today
                        </Button>
                        <Button variant="outlined"size='small' color='info' 
                                  onClick={doThisWeek}
                                  sx={{textTransform:'none'}}
                                  >
                          This Week
                      </Button>
                      <Button variant="outlined"size='small' color='info' 
                                  onClick={doThisMonth}
                                  sx={{textTransform:'none'}}
                                  //disabled={![phone, email, name,company].some(Boolean)}
                                  >
                         This Month
                      </Button>
                      <Button variant="outlined"size='small' color='info' 
                                  onClick={handleReset}
                                  sx={{textTransform:'none'}}
                                  >
                          All Days
                      </Button>
                    </Box>
                 </Grid>
                 <Grid item xs={24}   md={12} lg={12} >
                    <Box sx={{ display:'flex', flexDirection:'row', justifyContent: 'space-around' , m:0,p:0, 
                        width:'100%'}}>
                        <Button variant="outlined"size='small' 
                                onClick={doFilterApplication}
                                color='success'
                                sx={{textTransform:'none'}}

                              >
                            <SearchIcon sx={{display:{xs:'block', sm:'block'}}}/>
                            Filter
                        </Button>
                        
                      <Button variant="outlined"size='small'  
                                  onClick={doRefresh}
                                  color='success'
                                  sx={{textTransform:'none'}}
  
                                  //disabled={![phone, email, name,company].some(Boolean)}
                                  >
                          <RefreshIcon />
                          Refresh
                      </Button>
                    </Box>
                 </Grid>
              </Grid>
            </CardContent>
          </Collapse>
      </Card>       

  )

}

const PassItem = ({id, index})=>
{
  const dispatch = useDispatch()
  const it = useSelector(selectRequestById(id));
  const navigate = useNavigate()
    

  let createdTm = parse(it.createdTm, 'dd/MM/yyyy HH:mm:ss', new Date())
  createdTm = formatDistanceToNow (createdTm)

  const canDecide = (it.status==='INIT' && (it.type==='Courier'||it.type==='Visitor'))

  
  let displayedStatusColor= 'primary'

    if (it.status==='APPROVED')
    {
        displayedStatusColor='success.main'
    }
    else if (it.status==='DENIED' ) 
    {
        displayedStatusColor='warning.main'
    }

    let iconBgColor= it.status==='PENDING' ? 'primary.main' :'success.main'

   if (it.status==='DENIED') iconBgColor='warning.main'




  return(
    <>
      <Card sx={{width:'100%', border:1}}
        >
          <CardHeader
            sx={{my:0, py:0}}
            avatar={
              <Avatar size='small' sx={{  width:32, height:32}}>
                <>
                {index%3===0 && 
                  <InactivePassIcon size='small' sx={{ bgcolor: 'light.main' , width:32, height:32}}/>}
                {index%3!==0 &&
                    <PassIcon size='small' sx={{ bgcolor: `${iconBgColor}` , width:32, height:32}}/>
                }
                </>
               </Avatar>
            }
            action={
                  <Typography variant='body2' sx={{p:1}}>Pass No:&nbsp; {'P20031786S'}</Typography>
                    
                  
                  
             }
            title={<Typography sx={{m:0,p:0}}
              fontWeight={it.status==='PENDING' ? 450:350}
              variant='subtitle1'>{it.walkin>0 && <WalkinIcon color='success' sx={{fontSize:16}}/>}
              {it.reason}</Typography>}

            subheader={<Typography  variant='body2'><small>
              {index %3===0 ? 'Enrolled' :'Pending Enrolment'}
              </small></Typography>}
         />
         <CardContent sx={{p:0,mx:1}}>

              
          <Box sx={{ display: {xs:'block',md:'flex'}, py: 0, my:0, px:2,bgcolor: 'background.paper', }}  >

            <Box sx={{p:0,ml:2,flexGrow:1}}>
              <Grid  container  columns={12}  spacing={1}    sx={{m:0, p:0,}}  > 
                  <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'>
                          <strong>Name :&nbsp;</strong>{it.name}
                        </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'
                          > <strong>Phone :&nbsp;</strong>{it.phone}
                        </Typography>
                   </Grid>
                   <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'
                          > <strong>Email :&nbsp;</strong>{it.email}
                        </Typography>
                   </Grid>
                   <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'
                          > <strong>Organization :&nbsp;</strong>{it.company}
                        </Typography>
                   </Grid>
                </Grid>
                <Grid  container  columns={12}  spacing={1}    sx={{m:0, p:0,}}  > 

                    <Grid item xs={12} md={6} lg={3}>
                          <Typography variant='body2'
                            > <strong>Start Time :&nbsp;</strong>{it.startTm}
                          </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                          <Typography variant='body2'
                            > <strong>End Time :&nbsp;</strong>{it.endTm}
                          </Typography>
                    </Grid>
                   <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'
                          > <strong>Floor :&nbsp;</strong>{'Floor--'+(index+2)}
                        </Typography>
                   </Grid>
                   
                   <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'
                          > <strong>Remarks :&nbsp;</strong>{it.remarks}
                        </Typography>
                   </Grid>
                </Grid>
                <Grid  container  columns={12}  spacing={1}    sx={{m:0, p:0,}}  > 


                   <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'

                            > <strong>Status :&nbsp;</strong>
                            {it.status}
                                              </Typography>
                   </Grid>
                   {it.status!=='PENDING' &&
                  <Grid item xs={12} md={6} lg={9}>
                        <Typography variant='body2'
                          > <strong>Host Remarks :&nbsp;</strong>{it.hostRemarks}
                        </Typography>
                   </Grid>
                  }
              </Grid>
              
              </Box>
          </Box>
         </CardContent>
         { it.status==='PENDING' &&
          
            
            <CardActions sx={{px:2, mx:0,pt:0, mb:0, }}>
                  <Box sx={{display:'flex', justifyContent:'space-around', flexDirection:'row', width:'100%'}}>
                { (index %2) ===0 &&      
                  <Button variant="outlined" 
                    color='success'
                onClick ={ (e)=>{navigate('/request/approve/'+it.id);} }
              > <ApproveIcon/> Reactivete Entry and Pass
            </Button>
          }  

        { (index %2) ===1 &&
            <Button variant="outlined" 
              color='error'
                //variant="contained" color='error'  
                //disabled = {status==='success'}
                onClick ={ (e)=>{navigate('/request/deny/'+it.id);} }
              > <DenyIcon/>Deny Entry and Pass
            </Button>
        }
            </Box>
                 
        
            </CardActions>

              }

      </Card>
      
  
    </>
  );

}

const PassListPage = () => {

  const {
    setOp,
    status, setStatus, appTitle, setAppTitle, 
    errorMessage, setErrorMessage, errorTitle, setErrorTitle,
    setTenantLogo
  }=usePlayContext()


    const requestIds =  useSelector(selectRequestIds)


  useEffect(()=>{
      setErrorMessage('')
      setErrorTitle('')
      setAppTitle(['Access Management'])

      return ()=>{
        setErrorMessage('')
        setErrorTitle('')          
      }
  },[])

   
  return (

    <Stack sx={{ width: '100%' , mt:1}} spacing={2}>
    <InvitationFilterPane/>  
    {
      requestIds.map(  (id, index)=><PassItem key={id} id={id} index={index}/>)
    }
</Stack>
  );
};

export default PassListPage;
